import React, { PropsWithChildren } from "react"
import { PropsWithStyle } from "@rogue_4/types"
import classNames from "classnames"

import styles from "./index.module.less"

const ModalTitle = React.forwardRef<
    HTMLDivElement,
    PropsWithChildren<PropsWithStyle<{ brain?: boolean; noDeco?: boolean }>>
>(({ className, children, style, brain, noDeco }, ref) => {
    return (
        <div
            ref={ref}
            className={classNames(styles.modalTitle, className)}
            style={style}
        >
            <div className={styles.deco}></div>
            {brain && <div className={styles.brain}></div>}
            {!noDeco && <div className={styles.textDeco}></div>}
            <div className={styles.content}>{children}</div>
        </div>
    )
})
ModalTitle.displayName = "ModalTitle"

export default ModalTitle
